import { connect } from 'react-redux';
import QuestionNumber from './QuestionNumber';

const mapStateToProps = state => ({
  current: state.exam.currentQuestion + 1,
  total: state.exam.questions.length
});

const mapDispatchToProps = dispatch => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionNumber);
